import Vue from 'vue';
import Vuex from 'vuex';
import api from "../assets/js/api";
import auth from "../assets/js/auth";

Vue.use(Vuex);

export default new Vuex.Store({
    state : {
        systemEnum: {
            company : {
                admin : {},
                site : {},
                user : {
                    gender : {},
                },
                card : {},
                user_order: {},
                user_integral_order : {
                    status : {},
                },
                coupon_template : {
                    use_scene : {},
                },
                user_exchange : {
                    type : {},
                    status : {},
                },
                user_card_balance_log : {
                    type : {},
                    income_and_expenditure : {},
                },
                activity : {
                    type : {},
                },
            },
            oil_type : [],
            card_type : {
                DebitCard: {},
                FuelCapacityCard: {},
                PrepaidCard: {},
            },
        },
        userInfo : {},
        systemConfig: {}
    },
    mutations : {
        refreshSystemEnum(state){
            api.request('/common/get_all_enum').then(res => {
                state.systemEnum = res.data;
            });
        },
        refreshUserInfo(state){
            api.request('/user/info').then(res => {
                auth.setAuthInfo(res.data);  //获取当前用户信息
                state.userInfo = res.data;
            });
        },
        refreshSystemConfig(state){
            let cacheSystemConfig = localStorage.getItem('cacheSystemConfig');
            if(cacheSystemConfig){
                state.systemConfig = JSON.parse(cacheSystemConfig);
            }
            api.request('/common/get_system_config').then(res => {
                state.systemConfig = res.data;
                localStorage.setItem('cacheSystemConfig', JSON.stringify(res.data));
            });
        },
        syncUserInfo(state){
            state.userInfo = auth.getAuthInfo();
        },
    },
    getters : {

    },
    actions : {

    },
});



// WEBPACK FOOTER //
// ./src/store/index.js